import { fetch } from './http.util';
import { familyApiFetch } from './AuthProvider';
import { config } from './Config';

export async function getFuturePrices() {
  return await familyApiFetch(fetch, `${config.apiEndpoints.familyLifeBaseUri}power/homes/1f8947e4-f2e4-4127-97e0-412c49b8032f/prices`, {});
}

export async function getHomeUsage() {
  return await familyApiFetch(fetch, `${config.apiEndpoints.familyLifeBaseUri}power/homes/1f8947e4-f2e4-4127-97e0-412c49b8032f/usages`, {});
}

export async function getCabinUsage() {
  return await familyApiFetch(fetch, `${config.apiEndpoints.familyLifeBaseUri}power/homes/5cf04309-7b62-4a25-a6fb-92af3f96a3a7/usages`, {});
}
